import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Logo = ({
  width = 38,
  height = 41,
  fill = colors.light,
  responsive = false,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 41"
      aria-labelledby="logoTitle"
      focusable="false"
      role="img"
      ref={forwardRef}
      {...svgAttributes}
    >
      <title id="logoTitle">Royal Caribbean</title>
      <path
        fillRule="evenodd"
        fill={fill}
        clipRule="evenodd"
        d="M18.46.271c-.047.046-.091.09-.133.124-.714.688-1.439 1.364-2.164 2.04-1.203 1.121-2.406 2.243-3.556 3.42.302.394.614.782.925 1.17.486.606.973 1.213 1.427 1.846-2.048.893-4.1 1.775-6.151 2.658-.6-.406-1.203-.81-1.805-1.212-.768-.514-1.537-1.029-2.301-1.549.851-.922 1.703-1.848 2.527-2.798-.94-.657-1.864-1.336-2.789-2.015C2.98 2.881 1.52 1.808 0 .824.334 3.61.605 6.407.875 9.203c.117 1.216.235 2.432.358 3.648 6.716.004 13.432.004 20.15.003h15.113c.122-1.299.25-2.598.379-3.898.266-2.693.533-5.386.74-8.082-1.768 1.18-3.479 2.441-5.19 3.702-.631.465-1.262.93-1.897 1.392a32.61 32.61 0 001.463 1.661c.35.38.7.76 1.036 1.15-.576.392-1.156.778-1.735 1.165-.79.527-1.58 1.054-2.36 1.594-1.057-.464-2.117-.921-3.178-1.378-.593-.255-1.185-.51-1.778-.767-.102-.046-.206-.09-.31-.133-.302-.124-.605-.25-.863-.45.477-.625.967-1.24 1.459-1.855.288-.362.578-.724.864-1.088-1.35-1.384-2.763-2.702-4.176-4.02C20.336 1.272 19.722.7 19.113.121c-.234-.266-.46-.042-.654.149zm2.865 14.815c-6.61 0-13.219-.001-19.83.001.084.814.163 1.629.241 2.444l.145 1.484c1.977.002 3.954.001 5.93.001 2.373 0 4.745 0 7.117.003.008 2.655.006 5.31.005 7.965 0 1.99-.001 3.982.002 5.973-.765-.006-1.53-.003-2.295 0-1.395.006-2.79.012-4.183-.039-.642.041-1.209-.328-1.708-.686-.593-.448-1.09-1.256-.753-2.003.436-1.284 1.61-2.08 2.7-2.776-2.052-1.317-4.049-2.722-6.044-4.124l-.506-.356c.51 4.122 1.023 8.246 1.535 12.367 2.165.816 4.335 1.618 6.505 2.42A853.666 853.666 0 0118.854 41a3300.44 3300.44 0 0115.198-5.647c.246-1.916.482-3.833.719-5.75.273-2.214.546-4.428.833-6.641l-.787.554c-1.911 1.347-3.824 2.695-5.8 3.941 1.253.76 2.622 1.763 2.858 3.312-.164.928-.952 1.657-1.809 1.987-.337.17-.706.17-1.074.17-.181 0-.362 0-.54.02-1.18.017-2.358.014-3.537.012-.697-.002-1.393-.003-2.09 0v-6.97c0-2.325 0-4.648.002-6.971 1.69-.002 3.38-.001 5.072 0 2.657 0 5.315.001 7.973-.007.052-.785.121-1.57.19-2.355.046-.523.093-1.047.134-1.57H21.325z"
      />
    </svg>
  )
}

export default Logo
